import { render } from "./Testview.vue?vue&type=template&id=6f11d283&scoped=true"
import script from "./Testview.vue?vue&type=script&lang=js"
export * from "./Testview.vue?vue&type=script&lang=js"

import "./Testview.vue?vue&type=style&index=0&id=6f11d283&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f11d283"]])

export default __exports__